import { useId, useRef } from 'react';
import {
  InputWithLabelWrapper,
  TicketInfoLabel,
  StyledInput,
} from './TicketInfoField.styled';
interface TicketInfoFieldProps {
  labelText: string;
  displayValue: string | number;
}

export const TicketInfoField = ({
  labelText,
  displayValue,
}: TicketInfoFieldProps) => {
  const inputId = useId();
  const inputref = useRef<HTMLInputElement>();

  const handleFocus = () => {
    if (inputref.current) {
      inputref.current?.blur();
    }
  };

  return (
    <InputWithLabelWrapper>
      <TicketInfoLabel htmlFor={inputId} size="medium">
        {labelText}
      </TicketInfoLabel>
      <StyledInput
        appearance="outline"
        size="medium"
        readOnly
        value={String(displayValue)}
        id={inputId}
        ref={inputref}
        onFocus={handleFocus}
      />
    </InputWithLabelWrapper>
  );
};
